import Service from '../service';

export default class ApplicationSupplyService extends Service {
  baseApi = '/user/application-supply';
  archiveApi = '/user/application-supply-archive';

  async changeStatus(formData) {
    const url = `${this.baseApi}/status`;
    return await this.postFormData(url, formData);
  }

  async getStatusHistory(query) {
    const url = `${this.baseApi}/status`;
    return await this.getResource(url, query);
  }

  async getPrintForm(id) {
    const url = `${this.baseApi}/${id}/print`;
    return await this.getResource(url);
  }

  async getApplications(query) {
    const url = `${this.baseApi}`;
    return await this.getResource(url, query);
  }

  async getArchiveApplications(query) {
    const url = `${this.archiveApi}`;
    return await this.getResource(url, query);
  }

  async filter(query, field) {
    const url = `${this.baseApi}/filter/${field}`;
    return await this.getResource(url, query);
  }

  async filterArchive(query, field) {
    const url = `${this.archiveApi}/filter/${field}`;
    return await this.getResource(url, query);
  }

  async postApplication(formData) {
    const url = `${this.baseApi}`;
    return await this.postFormData(url, formData);
  }

  async postArchiveApplication(formData) {
    const url = `${this.archiveApi}`;
    return await this.postFormData(url, formData);
  }

  async getArchivableCount() {
    const url = `${this.archiveApi}/archivable-count`;
    return await this.getResource(url);
  }

  async executeArchive() {
    const url = `${this.archiveApi}/execute`;
    return await this.postResource(url, {});
  }

  async exportApplications(body) {
    const url = `${this.baseApi}/export`;
    return await this.postResource(url, body);
  }

  async importApplications(formData) {
    const url = `${this.baseApi}/import`;
    return await this.postFormData(url, formData);
  }

  async updateApplicationsSort(body) {
    const url = `${this.baseApi}/sort`;
    return await this.putResource(url, body);
  }

  async updateQueuePosition(body) {
    const url = `${this.baseApi}/queue`;
    return await this.putResource(url, body);
  }

  async getApplicationsQueue(query) {
    const url = `${this.baseApi}/queue`;
    return await this.getResource(url, query);
  }

  async exportQueueExcel(query) {
    const url = `${this.baseApi}/queue/export`;
    return await this.getResource(url, query);
  }

  async updateTon(body) {
    const url = `${this.baseApi}/ton`;
    return await this.putResource(url, body);
  }
}
